var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgFileMusicLine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8V10H13V14.5C12.9999 15.0159 12.8402 15.5191 12.5428 15.9407C12.2454 16.3622 11.8249 16.6814 11.3389 16.8545C10.8529 17.0276 10.3253 17.0462 9.82839 16.9076C9.33146 16.769 8.88958 16.4801 8.56335 16.0804C8.23711 15.6808 8.0425 15.19 8.0062 14.6754C7.9699 14.1608 8.09368 13.6476 8.36059 13.2061C8.62749 12.7646 9.02443 12.4165 9.49698 12.2095C9.96953 12.0025 10.4945 11.9468 11 12.05V8H15V4H5V20H19V8H16ZM3 2.992C3 2.444 3.447 2 3.999 2H16L21 7V20.993C21.0009 21.1243 20.976 21.2545 20.9266 21.3762C20.8772 21.4979 20.8043 21.6087 20.7121 21.7022C20.6199 21.7957 20.5101 21.8701 20.3892 21.9212C20.2682 21.9723 20.1383 21.9991 20.007 22H3.993C3.73038 21.9982 3.47902 21.8931 3.29322 21.7075C3.10742 21.5219 3.00209 21.2706 3 21.008V2.992Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgFileMusicLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file-music-line.942f5234460685e683c37cabfcc77f87.svg";